import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { HttpClient } from '@angular/common/http';
import { Security } from 'app/model/security.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Infra } from 'app/model/infra.model';
import { FuseUtils } from '@fuse/utils';

@Injectable({
    providedIn: 'root'
})
export class FltFilterService {
    activeFilterQuery: string;

    onFilterChange: BehaviorSubject<string> = new BehaviorSubject<string>('');
    onInfraChanged: BehaviorSubject<any>;

    private messageSource = new BehaviorSubject(null);

    currentMessage = this.messageSource.asObservable();
    security = new Security();
    searchText: string;
    infra: Infra[];

    /**
     * Constructor
     *
     * @param {MediaObserver} _mediaObserver
     */
    constructor(
        private _filterObserver: MediaObserver,
        private _httpClient: HttpClient
    ) {
        // Set the defaults
        this.activeFilterQuery = '';

        this.onInfraChanged = new BehaviorSubject([]);
        // Initialize
        this._init();
    }

    getInfraUserWorkspace(userEmail): Promise<any> {
        
        console.log(userEmail);
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.security.AppEngine + 'api/infra/' + userEmail)
                .subscribe((response: any) => {
                    console.log(this.infra);
                    this.infra = response.items;
                    
                    if (this.searchText && this.searchText !== '') {
                        this.infra = FuseUtils.filterArrayByString(this.infra, this.searchText);
                    }
                    this.infra = this.infra.map(infra => {
                        return new Infra(infra);
                    });
                    this.onInfraChanged.next(this.infra);
                    resolve(this.infra);
                }, reject);
        });
    }

    getInfra(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.security.AppEngine + 'api/infra')
                .subscribe((response: any) => {
                    this.infra = response.items;
                    if (this.searchText && this.searchText !== '') {
                        this.infra = FuseUtils.filterArrayByString(this.infra, this.searchText);
                    }
                    this.infra = this.infra.map(infra => {
                        return new Infra(infra);
                    });
                    this.onInfraChanged.next(this.infra);
                    resolve(this.infra);
                }, reject);
        });
    }

    changeMessage(message: any) {
        this.messageSource.next(message);
      }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void {
        this._filterObserver.media$
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((change: MediaChange) => {
                if (this.activeFilterQuery !== change.mqAlias) {
                    this.activeFilterQuery = change.mqAlias;
                    this.onFilterChange.next(change.mqAlias);
                }
            });
    }

}
